import React, { useMemo } from 'react';
import styled from 'styled-components';
import { Icon } from '@cld/icon';
import { ChipWithTooltip } from '../ChipWithTooltip/ChipWithTooltip';
import { ComplexityTag } from '../ComplexityTag/ComplexityTag';
import { isComplexityOption, SearchOption, useGetSearchQueryValue } from './SearchField.helper';

const IconButton = styled.button`
  background: none;
  border: none;
  padding: 0;
  line-height: 0.8;
`;

/**
 * Converts search query state into memoized chip components
 */
export const useSearchChips = (options: SearchOption[], onOptionsChange: (options: SearchOption[]) => void) => {
  const getSearchQueryValue = useGetSearchQueryValue();
  return useMemo(() => {
    const createCloseElement = (optionToRemove: SearchOption) => {
      const handleClick = () => onOptionsChange(options.filter((option) => option !== optionToRemove));
      return (
        <IconButton onClick={handleClick}>
          <Icon name="cross" size="xs" />
        </IconButton>
      );
    };

    return options.map((option) => {
      if (isComplexityOption(option)) {
        return <ComplexityTag key={option.complexity} complexity={option.complexity} rightSlot={createCloseElement(option)} />;
      }
      const queryValue = getSearchQueryValue(option);
      if (queryValue) {
        return <ChipWithTooltip key={queryValue} label={queryValue} rightSlot={createCloseElement(option)} />;
      }

      throw new Error(`unsupported option: ${JSON.stringify(option)}`);
    });
  }, [onOptionsChange, options, getSearchQueryValue]);
};
